import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/Home";

const routes = [
	{
		// Document title tag
		// We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
		meta: {
			title: "Dashboard",
		},
		path: "/",
		name: "home",
		//component: Home,
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ActiveRooms"),
	},
	{
		meta: {
			title: "Rooms",
		},
		path: "/rooms",
		name: "rooms",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ActiveRooms"),
	},
	{
		meta: {
			title: "Booking Rooms",
		},
		path: "/booking_rooms",
		name: "booking_rooms",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/BookingRooms"),
	},
	{
		meta: {
			title: "History",
		},
		path: "/history",
		name: "history",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/History"),
	},
	{
		meta: {
			title: "Room history",
		},
		path: "/history/:roomId",
		name: "roomHistory",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/RoomHistory"),
	},
	{
		meta: {
			title: "Users",
		},
		path: "/users",
		name: "users",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Users"),
	},
	{
		meta: {
			title: "Products",
		},
		path: "/products",
		name: "products",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Products"),
	},
	{
		meta: {
			title: "Product create",
		},
		path: "/product/create",
		name: "productCreate",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductCreate"),
	},
	{
		meta: {
			title: "Product upload",
		},
		path: "/product/upload",
		name: "productuUpload",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductUpload"),
	},
	{
		meta: {
			title: "Product edit",
		},
		path: "/product/:productId",
		name: "productEdit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/ProductEdit"),
	},
	{
		meta: {
			title: "Settings",
		},
		path: "/settings",
		name: "Settings",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/Settings"),
	},
	{
		meta: {
			title: "User create",
		},
		path: "/user/create",
		name: "userCreate",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/UserCreate"),
	},
	{
		meta: {
			title: "User edit",
		},
		path: "/user/:userId",
		name: "userEdit",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "rooms" */ "../views/UserEdit"),
	},
	{
		meta: {
			title: "Tables",
		},
		path: "/tables",
		name: "tables",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "tables" */ "../views/Tables"),
	},
	{
		meta: {
			title: "Forms",
		},
		path: "/forms",
		name: "forms",
		component: () => import(/* webpackChunkName: "forms" */ "../views/Forms"),
	},
	{
		meta: {
			title: "Profile",
		},
		path: "/profile",
		name: "profile",
		component: () => import(/* webpackChunkName: "profile" */ "../views/Profile"),
	},
	{
		meta: {
			title: "Ui",
		},
		path: "/ui",
		name: "ui",
		component: () => import(/* webpackChunkName: "profile" */ "../views/Ui"),
	},
	{
		meta: {
			title: "Login",
			formScreen: true,
		},
		path: "/login",
		name: "login",
		component: () => import(/* webpackChunkName: "login" */ "../views/Login"),
	},
	{
		meta: {
			title: "Widget API Tokens",
		},
		path: "/widgets",
		name: "widgets",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokens"),
	},
	{
		meta: {
			title: "Widget Statistics",
		},
		path: "/widgets/stats",
		name: "widgetStats",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetUsageStats"),
	},
	{
		meta: {
			title: "Create Widget Token",
		},
		path: "/widgets/create",
		name: "widgetTokenCreate",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokenForm"),
	},
	{
		meta: {
			title: "Edit Widget Token",
		},
		path: "/widgets/:id/edit",
		name: "widgetTokenEdit",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetTokenForm"),
	},
	{
		meta: {
			title: "Widget System Settings",
		},
		path: "/widgets/system-settings",
		name: "widgetSystemSettings",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetSystemSettings"),
	},
	{
		meta: {
			title: "Widget Plugin Manager",
		},
		path: "/widgets/plugins",
		name: "widgetPluginManager",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetPluginManager"),
	},
	{
		meta: {
			title: "Widget Sessions",
		},
		path: "/widgets/sessions",
		name: "widgetSessions",
		component: () => import(/* webpackChunkName: "widgets" */ "../views/WidgetSessions"),
	},

];

const router = createRouter({
	mode: "history",
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { top: 0 };
	},
});

export default router;
